<section class="container p-3">
  <div class="col-12 centrar banner">
      <h4>Mensaje de All Tickets</h4>
      <hr class="aaaa mb-1">
  </div>
  <div class="row">
      <div class="col-12 centrar">


          <p class="mensaje">
            {{ mensaje }}
            <br>
            <a href="https://codigos.allticketscol.com/Terminos+y+condiciones+MetLife.pdf" target="_blank">Términos y Condiciones</a>
          </p>
          <button class="botonNo" mat-button mat-dialog-close (click)="confirmar(false)">No</button>
          <button class="botonLogin mt-3 rounded" mat-button mat-dialog-close (click)="confirmar(true)">Sí</button>
      </div>
  </div>
</section>
